import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({

  breakpoints: {
    base: "480px",
    sm: "768px",
    md: "1024px",
    lg: "1200px",
    xl: "1350px",
    "2xl": "1400px",
  },

  colors: {
    red: {
      "400": "#ED1C24"
    },

    white: {
      "400": "#FFFFFF"
    },

    gray: {
      "100": "#FAFAFA",
      "200": "#F2F2F2",
      "300": "#EBEBEB",
      "400": "#ECECEC",
      "500": "#B7B7B7",
      "600": "#3B3B3B"
    },

    black: {
      "900": "#000",
      "600": "#EC1C24",
    },

    orange: {
      "400": "#FF4700"
    }
  },

  fonts: {
    heading: `'DM Sans', sans-serif`,
    body: `'DM Sans', sans-serif`
  },

  styles: {
    global: {
      body: {
        bg: "gray.100",
        color: "gray.600",
      },
    },
  },

  config: {
    useSystemColorMode: false,
    initialColorMode: "light",
  },
});
